import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import * as yup from 'yup';
import cx from 'classnames';
import noop from 'lodash/noop';
import storage from 'web-storage';

import Link from 'common/link';
import Icon from 'common/icon';
import Button from 'common/button';

const { localStorage } = storage();

class RegisterForm extends Component {
    initialValues = {
        firstName: '',
        lastName: '',
        email: localStorage.get('authUser.email') || '',
    };

    validate = yup.object().shape({
        firstName: yup.string().required(),
        lastName: yup.string().required(),
        email: yup
            .string()
            .email()
            .required(),
    });

    static propTypes = {
        register: PropTypes.func.isRequired,
        showFlash: PropTypes.func.isRequired,
        onRegister: PropTypes.func,
    };

    static defaultProps = {
        onRegister: noop,
    };

    handleSubmit = async (values, { setSubmitting, setFieldError }) => {
        const { register, showFlash, onRegister } = this.props;

        try {
            localStorage.set('authUser.email', values.email);
            await register({ variables: values });
            setSubmitting(false);
            onRegister();
        } catch (err) {
            if (err.message.includes('User already exists')) {
                showFlash({
                    type: 'info',
                    title: 'It looks like you already have an account!',
                    message: 'Please sign in or [reset your password](/forgot-password)',
                });

                setFieldError('email', true);
                setSubmitting(false);
                return;
            }

            showFlash({
                type: 'danger',
                title: 'Woops!',
                message:
                    'Something went wrong when trying to register your account. Please try again.',
                duration: 5000,
            });
            setSubmitting(false);
        }
    };

    render() {
        return (
            <Formik
                initialValues={this.initialValues}
                validationSchema={this.validate}
                onSubmit={this.handleSubmit}
            >
                {({ isSubmitting, touched, errors }) => (
                    <Form>
                        <Field
                            name="firstName"
                            placeholder="First name"
                            className={cx('input-default w-full', {
                                'is-invalid': touched.firstName && errors.firstName,
                            })}
                        />
                        <Field
                            name="lastName"
                            placeholder="Last name"
                            className={cx('input-default w-full mt-6', {
                                'is-invalid': touched.lastName && errors.lastName,
                            })}
                        />
                        <Field
                            type="email"
                            name="email"
                            placeholder="Email"
                            className={cx('input-default w-full mt-6', {
                                'is-invalid': touched.email && errors.email,
                            })}
                        />
                        <p className="text-center text-xs font-medium mt-4">
                            By registering, you agree to our{' '}
                            <Link to="/tos" className="link-green" external>
                                Terms of Service.
                            </Link>
                        </p>
                        <Button
                            type="submit"
                            color="green"
                            size="md"
                            className={cx('block w-full font-bold uppercase tracking-wide mt-12', {
                                'pointer-events-none opacity-60': isSubmitting,
                            })}
                        >
                            {isSubmitting ? (
                                <Icon icon="spinner" size="lg" className="leading-none" spin />
                            ) : (
                                'Register'
                            )}
                        </Button>
                    </Form>
                )}
            </Formik>
        );
    }
}

export default RegisterForm;
